var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotelHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 54,
    viewBox: "0 0 41 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0008 53.5C19.6008 53.5 19.3008 53.4 19.0008 53.1L18.6008 52.7C13.2008 46.4 0.500844 30.6 0.500844 19.5C0.400844 9.1 9.20084 0.599999 20.0008 0.499999C30.8008 0.399999 39.5008 9.1 39.5008 19.5C39.5008 32.7 21.7008 52.3 21.0008 53.1L20.9008 53.2C20.7008 53.4 20.3008 53.5 20.0008 53.5Z",
    fill: "url(#paint0_linear_4755_2960)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0008 1C30.5008 1.1 39.0008 9.4 39.0008 19.5C39.0008 24.8 35.9008 32.1 30.1008 40.6C27.2008 44.8 24.0008 48.9 20.6008 52.7L20.5008 52.8C20.4008 52.9 20.2008 53 20.0008 53C19.8008 53 19.6008 52.9 19.4008 52.8L19.0008 52.3C13.6008 46.1 1.00083 30.4 1.00083 19.5C1.00083 9.4 9.50083 1.1 20.0008 1ZM20.0008 0C8.90083 0.1 -0.0991747 8.8 0.000825341 19.5C0.000825341 32.9 18.0008 52.6 18.7008 53.4C19.0008 53.8 19.5008 54 20.0008 54C20.4008 54 20.9008 53.8 21.2008 53.6L21.3008 53.5C22.1008 52.6 40.0008 32.9 40.0008 19.5C40.1008 8.8 31.1008 0.1 20.0008 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 28C24.419 28 28.0007 24.4183 28.0007 20C28.0007 15.5817 24.419 12 20.0007 12C15.5825 12 12.0007 15.5817 12.0007 20C12.0007 24.4183 15.5825 28 20.0007 28Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4755_2960",
    x1: 40,
    y1: 22,
    x2: 1,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelHighlight);
export default __webpack_public_path__ + "static/media/hotel_highlight.4ded41f80f3cab2d18fd4280b601ddca.svg";
export { ForwardRef as ReactComponent };